export default __webpack_public_path__ + "static/media/regulatory--end-of-bicycles-only--g2.097b77a9.png";